import { Component, OnInit  } from '@angular/core';
import {  Router } from '@angular/router';
// import { OverviewGraphHistoryComponent } from '../graph-history/overview-graph-history/overview-graph-history.component';
declare var $: any;

@Component({
  selector: 'smart-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss','../platform-color/platform-color.css']
})


export class ReportComponent implements OnInit {
  dashboardName: string 
  template: string = ''
  pageActive:string='sensor-data-report'
  // @ViewChild(OverviewGraphHistoryComponent) plotEventCMP: OverviewGraphHistoryComponent;
  constructor(
    private router: Router
  ) {
  }

  ngOnInit() {
   
    this.template = sessionStorage.getItem("template")
    if(sessionStorage.getItem("page-report")){
      this.pageActive = sessionStorage.getItem("page-report")
    }
  }
 

  changePath(dashboardName: string) {
    this.dashboardName = dashboardName
    this.router.navigate(["/report/report"], { queryParams: { dashboardName } })
  }

  onClick(value:any) {
    this.pageActive = value
    sessionStorage.setItem("page-report", value);
  }
  

}
